import { useEffect } from 'react'
import { Button } from '@/common/ui/Form/Button'
import { Fieldset } from '@/common/ui/Form/Fieldset'
import { InputPassword } from '@/common/ui/Form'
import { useMe } from '@/common/entities/me/model/me'
import { useChangePasswordModel } from '../model'
import { cn } from '@/common/lib/cn/cn'

export const MeChangePasswordForm = ({ className }: { className?: string }) => {
    const { me } = useMe()
    const { form, register, handleSubmit, onSubmit, isPending, isSuccess, errors } = useChangePasswordModel()
    const hasPassword = me?.has_password === true

    useEffect(() => {
        if (isSuccess) {
            const checkbox = document.getElementById('changePasswordModal') as HTMLInputElement

            if (checkbox) {
                checkbox.checked = false
            }
            form.reset()
        }
    }, [isSuccess, form])

    return (
        <>
            <form method='post' className={cn('modal-form', className)} onSubmit={handleSubmit(onSubmit)}>
                <div className='modal-form-fields flex flex-col gap-[1.875rem]'>
                    {hasPassword && (
                        <Fieldset errorText={form.formState.errors.old_password?.message} required>
                            <InputPassword
                                className='w-full'
                                size='lg'
                                placeholder='Введите текущий пароль'
                                {...register('old_password', {
                                    required: 'Введите текущий пароль',
                                })}
                            />
                        </Fieldset>
                    )}
                    <Fieldset errorText={form.formState.errors.new_password?.message} required>
                        <InputPassword
                            className='w-full'
                            size='lg'
                            placeholder='Введите новый пароль'
                            {...register('new_password', {
                                required: 'Введите новый пароль',
                            })}
                        />
                    </Fieldset>
                    <Fieldset errorText={form.formState.errors.new_password_confirm?.message} required>
                        <InputPassword
                            className='w-full'
                            size='lg'
                            placeholder='Повторите новый пароль'
                            {...register('new_password_confirm', {
                                required: 'Повторите новый пароль',
                            })}
                        />
                    </Fieldset>
                    {errors.root && <p className='text-sm text-red-500'>{form.formState.errors.root?.message}</p>}
                </div>
                <div className='modal-form-actions'>
                    <Button
                        className='w-full'
                        emphasis='accent'
                        size='xl'
                        type='submit'
                        disabled={isPending}
                        loading={isPending}
                    >
                        Сохранить
                    </Button>
                    <Button
                        as='label'
                        htmlFor='changePasswordModal'
                        className='w-full'
                        emphasis='secondary'
                        size='lg'
                        variant='ghost'
                    >
                        Отмена
                    </Button>
                </div>
            </form>
        </>
    )
}
